import React, { useState, useEffect } from 'react';
import { Card, Form, Row, Col, Select, Button, Spin, DatePicker } from 'antd';
import { errHandler } from '../../helper/helper';
import { generateDistrictLoanReport } from "./LoanService";
import DistrictWiseLoanExcel from '../../Utils/Loan/DistrictWiseLoanExcel';
import { disabledDate } from "../../Utils/Util";

const { Option } = Select;
const { RangePicker } = DatePicker;

const DistrictLoanWiseReport = ({ loginPlaceId, districtData, districtName }) => {
    const [selections, setSelections] = useState({
        districts: [],
        startDate: null,
        endDate: null,
    });

    const [availableDistricts, setAvailableDistricts] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let filteredDistricts = [];

        if (loginPlaceId === "4") {
            filteredDistricts = districtData.filter(d => d.districtName === districtName);

            if (filteredDistricts.length > 0) {
                setSelections(prev => ({
                    ...prev,
                    districts: [filteredDistricts[0].districtId]
                }));
            }
        } else if (loginPlaceId === "3") {
            filteredDistricts = districtData;
        }

        setAvailableDistricts(filteredDistricts);
    }, [districtData, loginPlaceId, districtName]);

    const handleDistrictChange = (values) => {
        if (values.includes("ALL")) {
            setSelections(prev => ({
                ...prev,
                districts: availableDistricts.map(d => d.districtId)
            }));
        } else {
            setSelections(prev => ({ ...prev, districts: values }));
        }
    };

    const handleDateChange = (dates) => {
        setSelections(prev => ({
            ...prev,
            startDate: dates ? dates[0] : null,
            endDate: dates ? dates[1] : null
        }));
    };

    const generateReport = async () => {
        if (!selections.startDate || !selections.endDate) {
            errHandler("Please select date range");
            return;
        }

        if (selections.districts.length === 0) {
            errHandler("Please select at least one district");
            return;
        }

        const startDate = selections.startDate.format("YYYY-MM-DD");
        const endDate = selections.endDate.format("YYYY-MM-DD");

        const selectedDistrictNames = selections.districts
            .map(id => availableDistricts.find(d => d.districtId === id)?.districtName)
            .filter(Boolean);

        const requestData = {
            selectedDate: startDate,
            endDate: endDate,
            districtIdList: selections.districts,
        };

        try {
            setLoading(true);

            const response = await generateDistrictLoanReport(requestData);

            let reportData;

            if (response?.data && Array.isArray(response.data)) {
                reportData = response.data;
            }
            else if (response?.data && typeof response.data === 'object') {
                const dataObj = response.data;
                const keys = Object.keys(dataObj);

                for (let key of keys) {
                    if (Array.isArray(dataObj[key])) {
                        reportData = dataObj[key];
                        break;
                    }
                }

                if (!reportData && dataObj.districtName) {
                    reportData = [dataObj];
                }
            }
            else if (Array.isArray(response)) {
                reportData = response;
            }

            if (!reportData || !Array.isArray(reportData) || reportData.length === 0) {
                errHandler("No data found for selected criteria");
                return;
            }

            DistrictWiseLoanExcel(
                reportData,
                startDate,
                endDate,
                selectedDistrictNames,
                loginPlaceId
            );

        } catch (err) {
            errHandler("Failed to generate report");
        } finally {
            setLoading(false);
        }
    };

    const isGenerateDisabled =
        loading ||
        !selections.startDate ||
        !selections.endDate ||
        !selections.districts.length;

    return (
        <div className="panel-container">
            <Card hoverable className="inner-card">
                <Form layout="vertical">

                    {loginPlaceId === "3" && (
                        <Row gutter={[16, 16]}>
                            <Col span={24}>
                                <Form.Item label="Select Districts">
                                    <Select
                                        mode="multiple"
                                        placeholder="Select districts"
                                        style={{ width: '100%' }}
                                        value={selections.districts}
                                        onChange={handleDistrictChange}
                                        showSearch
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().includes(input.toLowerCase())
                                        }
                                        maxTagCount="responsive"
                                    >
                                        <Option key="ALL" value="ALL">Select All Districts</Option>
                                        {availableDistricts.map(d => (
                                            <Option key={d.districtId} value={d.districtId}>
                                                {d.districtName}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                    )}

                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <Form.Item label="Select Date Range">
                                <RangePicker
                                    onChange={handleDateChange}
                                    disabledDate={disabledDate}
                                    style={{ width: '100%' }}
                                    format="YYYY-MM-DD"
                                />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <Form.Item className="generate-btn-outline">
                                <Button
                                    onClick={generateReport}
                                    disabled={isGenerateDisabled}
                                    className="generate-btn"
                                    style={{ width: '100%' }}
                                    type="primary"
                                >
                                    {loading ? <Spin /> : 'Generate Report'}
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>

                </Form>
            </Card>
        </div>
    );
};

export default DistrictLoanWiseReport;